export default {
	properties: [
		{
			text: 'N°',
			key: 'num',
			type: 'number',
			not_show_on_form: true,
		},
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			is_title: true,
		},
		{
			text: 'Saldo',
			key: 'saldo_pesos',
			only_show: true,
			type: 'number',
			value: '',
			show: true,
			is_price: true,
			use_to_filter_in_modal: true,
			filter_modal_position: 2,
		},
		{
			text: 'Saldo USD',
			key: 'saldo_dolares',
			only_show: true,
			type: 'number',
			value: '',
			show: true,
			is_price: true,
			use_to_filter_in_modal: true,
			filter_modal_position: 2,
			if_has_extencion: 'ventas_en_dolares',
		},
		{
			text: 'Margen de ganancia',
			key: 'percentage_gain',
			type: 'number',
		},
		{
			text: '% de comision ventas en NEGRO',
			key: 'porcentaje_comision_negro',
			type: 'number',
			if_has_extencion: 'comision_por_proveedores',
			not_show: true,
		},
		{
			text: '% de comision ventas en BLANCO',
			key: 'porcentaje_comision_blanco',
			type: 'number',
			if_has_extencion: 'comision_por_proveedores',
			not_show: true,
		},
		{
			text: 'Valor dolar',
			key: 'dolar',
			type: 'number',
			is_price: true,
		},
		{
			text: 'Telefono',
			key: 'phone',
			type: 'text',
		},
		{
			text: 'Direccion',
			key: 'address',
			type: 'text',
		},
		{
			text: 'Correo',
			key: 'email',
			type: 'text',
			not_show: true,
		},
		{
			text: 'Razon social',
			key: 'razon_social',
			type: 'text',
			not_show: true,
		},
		{
			text: 'Cuit',
			key: 'cuit',
			type: 'text',
			check_length: 11,
		},
		{
			text: 'Observaciones',
			key: 'observations',
			type: 'textarea',
		},
		{
			text: 'Provincia',
			key: 'provincia_id',
			type: 'search',
			use_store_models: true,
		},
		{
			text: 'Localidad',
			key: 'location_id',
			type: 'search',
		},
		{
			text: 'IVA',
			key: 'iva_condition_id',
			type: 'select',
			value: 0,
		},
		{
			text: 'Descuentos',
			key: 'provider_discounts',
			has_many: {
				text: 'Descuento',
				model_name: 'provider_discount',
			}
		},
		// {
		// 	text: 'Listas de precios',
		// 	key: 'provider_price_lists',
		// 	has_many: {
		// 		text: 'Lista de precios',
		// 		model_name: 'provider_price_list',
		// 	},
		// 	not_show: true,
		// },
	],
	singular_model_name_spanish: 'Proveedor',
	plural_model_name_spanish: 'Proveedores',
	create_model_name_spanish: 'Nuevo proveedor',
	text_delete: 'el',
	show_all_models_on_display: false,
}